import React from 'react';
import { WrapContent } from './styles';

const Content = (props: any) => {
  const { children, isScrollDisabled } = props;
  return (
    <WrapContent id="WrapScroll" isScrollDisabled={isScrollDisabled}>
      {children}
    </WrapContent>
  );
};

export { Content };
